import useTranslate from '../../../../modules/local/useTranslate'
import React, {useMemo, useState} from 'react'
import {NullAsDefault} from '../../../Shared'
import {createModalTitle} from '../../../../components/renderFunctions/createModalTitle'
import {Modal} from 'antd'
import {useCourseClassAbsenceRequestApi} from './useCourseClassAbsenceRequestApi'
import {CourseClassAbsenceRequestCreateForm} from '../CourseClass/CourseClassAbsenceRequestForm'
import {showConfirmDialog} from '../../factory/createConfirmDialog'

export const useCourseClassAbsenceRequestForm = ({student, course_class_id, course_classes = []}) => {
  const t = useTranslate()

  const [refresh_token, set_refresh_token] = useState()

  const [action, setAction] = useState({
    type: undefined,
    value: undefined,
  })

  const onCancel = () => setAction({})

  const onRefresh = () => {
    onCancel()
    set_refresh_token(Date.now())
  }

  const {
    createAbsenceRequest,
    creatingAbsenceRequestAsync,
    cancelAbsenceRequest,
  } = useCourseClassAbsenceRequestApi({
    notifyListeners: {
      onSuccess: (__, data) => onRefresh(),
    },
  })

  const handleAction = (action, params) => {
    switch (action) {
      case 'CREATE_ABSENCE_REQUEST':
        setAction({type: action, value: params})
        break
      case 'CANCEL_ABSENCE_REQUEST':
        showConfirmDialog({
          translate: t,
          onOk: () => cancelAbsenceRequest({}, {id: params?.id}),
        })
        break
      default:
        break
    }
  }

  const modal = useMemo(() => {
    let params = {}
    let modal_params = {}
    let Component = NullAsDefault

    switch (action?.type) {
      case 'CREATE_ABSENCE_REQUEST':
        modal_params = {
          title: createModalTitle('create absence request'),
          width: 520,
        }
        params = {
          initialValues: {
            student_id: student?.id,
            course_class_id,
            course_classes,
            ...(action?.value || {}),
          },
          isSubmitting: creatingAbsenceRequestAsync.isLoading,
          onSubmit: (values) => createAbsenceRequest(values, {id: course_class_id}),
        }
        Component = CourseClassAbsenceRequestCreateForm
        break
      default:
        break
    }

    return (
      <Modal
        footer={null}
        onCancel={onCancel}
        open={action?.type}
        destroyOnHidden={true}
        className="custom-modal"
        {...modal_params}>
        <Component {...{onCancel}} {...params}/>
      </Modal>
    )
  }, [action, student?.id, course_class_id, creatingAbsenceRequestAsync.isLoading])

  return {modal, action, handleAction, refresh_token}
}
